<template>
  <el-dialog
    v-drag
    :title="editData.id ? '修改' : '新增'"
    :visible.sync="dialogVisible"
    width="800px"
    :show-close="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div class="content">
      <el-form ref="form" class="form" :model="form" :rules="rules">
        <div class="form-item">
          <label class="lable"><span class="red">* </span>类型</label>
          <el-form-item prop="type">
            <el-radio-group v-model="form.type">
              <el-radio :label="0">航司</el-radio>
              <el-radio :label="1">船司</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div class="form-item">
          <label class="lable"><span class="red">* </span>代码</label>
          <el-form-item prop="code">
            <el-input
              v-model="form.code"
              style="width: 320px"
              placeholder="请输入代码"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item">
          <label class="lable"><span class="red">* </span>中文名称</label>
          <el-form-item prop="nameCH">
            <el-input
              v-model="form.nameCH"
              style="width: 320px"
              placeholder="请输入备注内容"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item">
          <label class="lable"><span class="red">* </span>英文名称</label>
          <el-form-item prop="nameEN">
            <el-input
              v-model="form.nameEN"
              style="width: 320px"
              placeholder="请输入备注内容"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item" style="width: 100%; margin-left: 0">
          <label class="lable">网址</label>
          <el-form-item prop="website">
            <el-input
              v-model="form.website"
              style="width: 660px"
              placeholder="请输入网址"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item" style="width: 100%; margin-left: 0">
          <label class="lable">备注</label>
          <el-form-item prop="remark">
            <el-input
              v-model="form.remark"
              style="width: 660px"
              placeholder="请输入备注内容"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取 消</div>
      <div class="ok flex_c_c" @click="ok('form')">确 定</div>
    </span>
  </el-dialog>
</template>

<script>
import { insertTransport, updateTransport } from '@/api/basic'
import { mapGetters } from 'vuex'
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      form: {
        type: 0,
        code: '',
        nameCH: '',
        nameEN: '',
        website: '',
        remark: ''
      },
      rules: {
        type: [{ required: true, message: '请选择线路类型', trigger: 'blur' }],
        code: [{ required: true, message: '请输入代码', trigger: 'blur' }],
        nameCH: [{ required: true, message: '请输入中文名', trigger: 'blur' }],
        nameEN: [{ required: true, message: '请输入英文名', trigger: 'blur' }]
      }
    }
  },
  computed: {
    ...mapGetters(['addressDropOption'])
  },
  watch: {
    dialogVisible: function() {
      if (this.editData.id) {
        this.form = {
          ...this.editData
        }
      } else {
        this.form = {
          type: 0,
          code: '',
          nameCH: '',
          nameEN: '',
          website: '',
          remark: ''
        }
      }
    }
  },
  methods: {
    cancel() {
      this.$refs['form']?.resetFields()
      this.$emit('cancel')
    },
    ok(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            ...this.form
          }
          if (!this.editData.id) {
            insertTransport(params).then((res) => {
              if (res.success) {
                this.$message.success('新增成功')
                this.$refs['form']?.resetFields()
                this.$emit('ok')
              } else {
                this.$message.error(res.errorMessage)
              }
            })
          } else {
            updateTransport(params).then((res) => {
              if (res.success) {
                this.$message.success('修改成功')
                this.$refs['form']?.resetFields()
                this.$emit('ok')
              } else {
                this.$message.error(res.errorMessage)
              }
            })
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  width: calc(100% - 120px);
  height: auto;
  margin: 0 auto;
  text-align: left;
  .form {
    display: flex;
    width: 100%;
    height: auto;
    flex-wrap: wrap;
  }
  .form-item {
    width: calc(50% - 20px);
    position: relative;
    .lable {
      width: 100%;
      height: 19px;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 20px;
      margin-bottom: 5px;
    }
    .red {
      color: rgba(255, 116, 68, 1);
    }
    &:nth-child(2n) {
      margin-left: 40px;
    }
  }
}
/deep/ .el-dialog__body {
  padding: 20px 20px;
}
.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 16px;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background:  rgb(18,88,188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    cursor: pointer;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}
</style>
